import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import Modal from "../../../components/shared/Modal";
import DataTable from "../../../components/shared/DataTable";
import api from "../../../utils/api";

export default function TestCategories() {
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ categoryName: "", testType: "", description: "" });

  const { data, isLoading } = useQuery("test-categories", () =>
    api.get("/admin/test-categories")
  );

  const saveMutation = useMutation(
    () =>
      editing
        ? api.put(`/admin/test-categories/${editing.id}`, form)
        : api.post("/admin/test-categories", form),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("test-categories");
        toast.success(editing ? "Updated" : "Category added");
        setShowModal(false);
        setEditing(null);
        setForm({ categoryName: "", testType: "", description: "" });
      },
    }
  );

  const deleteMutation = useMutation(
    (id) => api.delete(`/admin/test-categories/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("test-categories");
        toast.success("Deleted");
      },
    }
  );

const openEdit = (row) => {
  setEditing(row);
  setForm({
    categoryName: row.category_name,   // ← was row.categoryName
    testType: row.test_type,           // ← was row.testType
    description: row.description,
  });
  setShowModal(true);
};

  const columns = [
     { key: "category_name", label: "Category (e.g. Blood)", sortable: true },  // ← was "categoryName"
  { key: "test_type", label: "Test Type (e.g. Diabetics)", sortable: true }, // ← was "testType"
  { key: "description", label: "Description" },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-2">
          <button
            onClick={() => openEdit(row)}
            className="text-xs px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
          >
            Edit
          </button>
          <button
            onClick={() => deleteMutation.mutate(row.id)}
            className="text-xs px-3 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <button
          onClick={() => {
            setEditing(null);
            setForm({ categoryName: "", testType: "", description: "" });
            setShowModal(true);
          }}
          className="btn-primary"
        >
          + Add Category
        </button>
      </div>

      <DataTable
        columns={columns}
        data={data?.categories || []}
        loading={isLoading}
        emptyMessage="No test categories yet."
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editing ? "Edit Test Category" : "Add Test Category"}
        footer={
          <>
            <button
              onClick={() => setShowModal(false)}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => saveMutation.mutate()}
              disabled={saveMutation.isLoading}
              className="btn-primary"
            >
              {saveMutation.isLoading ? "Saving…" : "Save"}
            </button>
          </>
        }
      >
        <div className="space-y-4">
          {[
            { field: "categoryName", label: "Category Name (e.g. Blood, Urine)" },
            { field: "testType", label: "Test Type (e.g. Diabetics, Platelet Count)" },
            { field: "description", label: "Description" },
          ].map(({ field, label }) => (
            <div key={field}>
              <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
                {label}
              </label>
              <input
                type="text"
                value={form[field]}
                onChange={(e) =>
                  setForm((f) => ({ ...f, [field]: e.target.value }))
                }
                className="input-field"
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}
